var icon = require('vue-svgicon')
icon.register({
  'ks-icon-contract': {
    width: 128,
    height: 128,
    viewBox: '10 10 108 108',
    data: '<path pid="1" d="M96.089 67.78l-23.94 23.94h-9.66v-9.66l23.94-23.94 9.66 9.66m14.28-3.36c0 1.26-1.26 2.52-2.52 3.78l-10.5 10.5-3.78-3.78L104.489 64l-2.52-2.52-2.94 2.94-9.66-9.66 9.24-8.82c.84-.84 2.52-.84 3.78 0l5.88 5.88c.84.84.84 2.52 0 3.78-.84.84-1.68 1.68-1.68 2.52 0 .84.84 1.68 1.68 2.52 1.26 1.26 2.52 2.52 2.1 3.78M25.949 97.6V30.4h29.4v21h21v6.3l8.4-8.4v-2.1L59.549 22h-33.6c-4.62 0-8.4 3.78-8.4 8.4v67.2c0 4.62 3.78 8.4 8.4 8.4h50.4c4.62 0 8.4-3.78 8.4-8.4h-58.8m33.6-12.18c-.84 0-1.68.42-2.1.42l-2.1-9.24h-6.3l-8.82 7.14 2.52-11.34h-6.3l-4.2 21h6.3l12.18-10.92 2.52 9.66h4.2l2.1-.42v-6.3z" fill-rule="nonzero" serif:id="contract"/>'
  }
})
